import { render, staticRenderFns } from "./AtualizacaoProcesso.vue?vue&type=template&id=fd9fb040&scoped=true&"
import script from "./AtualizacaoProcesso.vue?vue&type=script&lang=js&"
export * from "./AtualizacaoProcesso.vue?vue&type=script&lang=js&"
import style0 from "./AtualizacaoProcesso.vue?vue&type=style&index=0&id=fd9fb040&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9fb040",
  null
  
)

export default component.exports